import AskAiBar from './AskAiBar.jsx'
import HeroBriefCard from './HeroBriefCard.jsx'
import ScheduleScreen from './ScheduleScreen.jsx'
import CateringScreen from './CateringScreen.jsx'
import ScheduleSuggestionsSection from './ScheduleSuggestionsSection.jsx'
import { useHeroBrief } from '../hooks/useHeroBrief.js'

// Schedule hub — single tab in the top nav that holds the staff
// schedule (weekly roster) and the catering board (forward bookings)
// as sub-views. Both are forward-looking calendar concerns: who's
// working / who's coming.
//
// The sub-tab pill nav itself lives in App.jsx so it stays visible
// (sticky) while scrolling inside a sub-screen.
//
// Roster inherits the parent schedule-hub brief; catering has its
// own dedicated brief (forward bookings + last quote outcomes are a
// distinct synthesis from coverage + upcoming catering on the hub
// view).
export const SCHEDULE_SUBS = [
  { id: 'roster',   label: 'Roster' },
  { id: 'catering', label: 'Catering' },
]

// Sub-keyed placeholder copy for the AskAiBar — same pattern as the
// Stock hub.
const ASK_PLACEHOLDER_BY_SUB = {
  roster:   "Who's free Sunday morning?",
  catering: 'Quote me a 30-person lunch…',
}

const HERO_SUB_BY_SUB = {
  catering: 'catering',
}

export default function ScheduleHubScreen({ sub }) {
  const heroSubKey = HERO_SUB_BY_SUB[sub] || null
  const hero = useHeroBrief('schedule', heroSubKey, { enabled: true })

  let body = null
  if (sub === 'roster')   body = <ScheduleScreen />
  if (sub === 'catering') body = <CateringScreen />
  if (!body) return null

  const placeholder = ASK_PLACEHOLDER_BY_SUB[sub] || 'Ask AI anything…'

  return (
    <>
      <div className="mx-auto max-w-screen-sm">
        <HeroBriefCard
          tabKey="schedule"
          subKey={heroSubKey}
          phase={hero.phase}
          brief={hero.brief}
          error={hero.error}
          generatedAt={hero.generatedAt}
          onGenerate={hero.regenerate}
        />
        {sub === 'roster' && <ScheduleSuggestionsSection />}
      </div>
      {body}
      <AskAiBar placeholder={placeholder} />
    </>
  )
}
